import { focusHelper, removeFocusHelper } from "../helpers/focus-helper.js";

const searchForm = document.querySelector("form.search-form") ? document.querySelector("form.search-form") : false;
const dropdownButtons = searchForm ? Array.from(searchForm.querySelectorAll(".dropdown-button")) : false;
const searchField = document.querySelector("#s") ? document.querySelector("#s") : false;

const closeDropdowns = (ref) =>
    dropdownButtons.map((button) => (button !== ref ? button.setAttribute("aria-expanded", false) : false));

const checkDropdownClosed = (button) => button.getAttribute("aria-expanded") === "false";

function toggleDropdown(event) {
    event.stopPropagation();
    let isOpen = this.getAttribute("aria-expanded") === "true";
    this.setAttribute("aria-expanded", !isOpen);

    if (this.getAttribute("aria-expanded")) {
        closeDropdowns(this);
    }
    if (this.getAttribute("aria-expanded") === "true") {
        focusHelper(this.parentElement, this);
    } else {
        removeFocusHelper(this);
    }
}

if (dropdownButtons) {
    dropdownButtons.forEach((button) => {
        button.addEventListener("click", toggleDropdown);
    });
}

document.addEventListener("keydown", (event) => {
    if (!dropdownButtons) return;
    const everyTest = dropdownButtons.every(checkDropdownClosed);
    if (everyTest) return;

    if (event.target.closest(".dropdown-list") !== null && event.code.toUpperCase() === "ESCAPE") {
        event.target.closest(".dropdown-list").previousElementSibling.setAttribute("aria-expanded", false);
    }
});

window.addEventListener("click", (event) => {
    if (!dropdownButtons) return;
    const everyTest = dropdownButtons.every(checkDropdownClosed);

    if (everyTest) return;

    if (event.target.closest(".dropdown-list") === null) {
        dropdownButtons.map((button) => button.setAttribute("aria-expanded", false));
    }
});

if (searchField) {
    searchField.addEventListener("focus", () => {
        if (searchField.classList.contains("focus-visible")) {
            searchField.parentElement.classList.add("focus-visible");
        }
    });

    searchField.addEventListener("blur", () => {
        if (searchField.parentElement.classList.contains("focus-visible")) {
            searchField.parentElement.classList.remove("focus-visible");
        }
    });
}
